<template>
  <div
    v-if="artist"
    class="s_tooltip"
    :style="{transform: `translate(${x}px,${y}px)`}"
  >
    <span class="name">
      <b>{{ artist.name }} </b> 
      <span v-if="artist.birth_year">({{ artist.birth_year.split('-')[0] }})</span> 
      <small
        v-else
        class="has-text-grey is-size-7 has-text-weight-normal"
      >Unknown birth date</small> 
    </span>
    <div class="detail">
      Has adapted <b>{{ artist.score_level_plus_1 }}</b> songs
    </div>
    <div class="detail">
      Was adapted <b>{{ artist.score_level_minus_1 }}</b> times
    </div>
    <div class="detail">
      Was involved in <b>{{ artist.score_level_0 }}</b> songs
    </div>
  </div>
</template>

<script>
export default {
	props: {
		artist: {
			required: true
		}
	},
	data () {
		return {
			x: 0,
			y: 0
		};
	},
	computed: {
	},
	created () {
		window.addEventListener("mousemove", this.onMouseMove);
	},
	destroyed () {
		window.removeEventListener("mousemove", this.onMouseMove);
	},
	methods: {
		onMouseMove (payload) {
			this.x = payload.clientX;
			this.y = payload.clientY;
		}
	}
};
</script>

<style lang="scss" scoped>
.s_tooltip {
    position: fixed;
    top: 5px;
    left: 5px;
    border-radius: 5px;
    padding: 0.75rem;
    padding-top: 0.5rem;
    box-shadow: 1px 1px 3px rgba(0,0,0,0.15);
    z-index: 2;
    background-color: rgba(255,255,255,0.9);

    .name {
      font-size: 0.9rem;
      margin-bottom: 0.4rem;
    }

    .detail {
      font-size: 0.9rem;
    }
}
</style>
